import diffState, { type Change } from "./diffState";
import type { Actor, Observed } from "./system";

const LOG_SIZE = 100;

type LogEntry = Omit<Observed, "state"> & { changes: Change[] };

type DevConsoleState = { log: LogEntry[]; states: Record<string, unknown> };

type DevConsoleMsg =
  | { type: "observed"; observed: Observed }
  | { type: "clear" };

const devConsole: Actor<DevConsoleState, DevConsoleMsg> = {
  init: { log: [], states: {} },
  receive: (state, msg) => {
    switch (msg.type) {
      case "observed": {
        const { at, to, msg: observedMsg, state: next } = msg.observed;
        const changes = diffState(state.states[to], next);
        return {
          log: [...state.log, { at, to, msg: observedMsg, changes }].slice(
            -LOG_SIZE,
          ),
          states: { ...state.states, [to]: next },
        };
      }
      case "clear":
        return { ...state, log: [] };
      default:
        return state;
    }
  },
};

export default devConsole;
export type { DevConsoleMsg, DevConsoleState, LogEntry };
